import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoPatientEligibilityStatusNoteModalTemplate } from 'themes/application/niko-patient/components';
import { NikoPatientEligibilityStatusNoteModalStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoPatientEligibilityStatusNoteModalStore(rootStore, componentProps), 'nikoPatientEligibilityStatusNoteModalStore')
@observer
class NikoPatientEligibilityStatusNoteModal extends React.Component {
    render() {
        return <NikoPatientEligibilityStatusNoteModalTemplate {...this.props} />
    }
}

export default NikoPatientEligibilityStatusNoteModal;